import React from 'react';
import { Typography, Alert } from 'antd';
import { BookOutlined, InfoCircleOutlined } from '@ant-design/icons';
import DifyChatSDK from './DifyChatSDK';

const { Title, Paragraph } = Typography;

const KnowledgeBaseSearch: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>
        <BookOutlined /> 主数据与系统API顾问
      </Title>
      <Paragraph>
        智能查询主数据结构（77张表）和框架API接口，快速获取字段说明、表关联、接口定义等技术信息
      </Paragraph>

      <Alert
        message="Token 使用优化建议"
        description={
          <div>
            <ul style={{ marginBottom: 0 }}>
              <li>每次对话都会保留上下文，建议问完一个主题后重置对话</li>
              <li><strong>使用聊天窗口右上角的重置按钮</strong>可以清除对话历史，开始新对话</li>
              <li>尽量使问题简洁明确，获得答案后再提下一个问题</li>
              <li>定期重置对话可以有效节省 Token 消耗</li>
            </ul>
          </div>
        }
        type="info"
        icon={<InfoCircleOutlined />}
        showIcon
        style={{ marginBottom: 16 }}
        closable
      />

      {/* Dify 聊天机器人 - 使用 SDK 方式避免 401 错误 */}
      <DifyChatSDK 
        height="700px"
        showHeader={true}
      />
    </div>
  );
};

export default KnowledgeBaseSearch;